import { KeywordsTypes } from '../components/ui/CreatePostModal/helpers';

export const parseToKeywordType = (keywords?: KeywordsTypes[]): KeywordsTypes[] => {
  if (!keywords) return [];
  const keys = keywords.map<KeywordsTypes>((key) => ({ keyword: key.keyword }));
  return keys;
};
